/*
  Подтверждение удаления или отмены на карточке счёта (20.10.2026): общее для начислений,
  оплат, проживающих и должников. Каркас - `Confirm` из общих компонентов; здесь только
  то, чем эти окна отличаются от остальных: запрос идёт отсюда, а отказ остаётся в окне.
*/

import { useState } from 'react'

import { Confirm } from '../Common.jsx'

export default function RemoveDialog({ title, action, onRemove, onDone, onClose, children }) {
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState(null)

  async function confirm() {
    setBusy(true)
    setError(null)
    try {
      await onRemove()
    } catch (failure) {
      setError(failure)
      setBusy(false)
      return
    }
    onDone()
    onClose()
  }

  return (
    <Confirm title={title} action={action} onConfirm={confirm} onCancel={onClose} busy={busy} error={error}>
      {children}
    </Confirm>
  )
}
